import callApi from 'res-api-cli/build/callApi';
import type { CreateEvidenceBundleRequest, CreateEvidenceBundleResponse } from 'components/Complaints/Complaint/EvidenceV2/types/bundle';

/**
 * POST /cms/evidence-bundles
 *
 * Initiates an asynchronous ZIP bundle job for ≥2 evidence files.
 * Returns immediately with status PENDING and a bundleId to poll against.
 *
 * @see CD-7668 plan — Task 3.2
 */
const createEvidenceBundle = (params: CreateEvidenceBundleRequest): Promise<CreateEvidenceBundleResponse> =>
  callApi({
    method: 'POST',
    url: '/cms/evidence-bundles',
    data: params,
  });

export default createEvidenceBundle;
